import { useAuth } from "@entities/auth";
import { useQuery } from "@tanstack/react-query";
import { useGetMe } from "./useGetMe";

export default function useSendMfaOtp() {
  const { sendMFAOTP, user } = useAuth();
  const { userDetails } = useGetMe();
  const { data, isFetching, isSuccess, error, refetch, isFetched } = useQuery({
    queryKey: ["sendMFAOTP"],
    queryFn: () => sendMFAOTP(),
    enabled: !!user && !!userDetails,
  });

  return {
    otpData: data,
    isSendingOtp: isFetching,
    isOtpSent: isSuccess,
    otpError: error,
    refetchOtp: refetch,
    isOtpFetched: isFetched,
  };
}
